import httpClient from '../httpClient';

export const getOrderList = async (idCustomer, filter, page) => {
  const result = await httpClient.get('/order/get', {
    params: {
      filter: filter,
      idCustomer: idCustomer,
      ...(page === undefined ? {} : { page, pageSize: 10 }),
    },
  });
  return result.data;
};

export const getPreviousInvoices = async (idCustomer, filter, page = 1) => {
  const result = await httpClient.get('/order/previous-invoices', {
    params: {
      filter: filter,
      idCustomer: idCustomer,
      page,
      pageSize: 10,
    },
  });
  return result.data;
};

export const downloadInvoicePdf = async (idCustomer, invoiceNumber) => {
  const result = await httpClient.get('/order/invoice-pdf', {
    params: {
      idCustomer,
      invoiceNumber,
    },
    responseType: 'blob',
  });
  return result.data;
};

export const checkSOExists = async (customerPO) => {
  const result = await httpClient.get('/order/check-exist', {
    params: {
      customerPO: customerPO,
    },
  });
  return result.data;
};

export const getOrderBillAddr = async (idSO, idCustomer) => {
  const result = await httpClient.get(`/order/get-bill-addr`, {
    params: {
      idSO: idSO,
      idCustomer: idCustomer,
    },
  });
  return result.data;
};

export const getOrderShipAddr = async (idSO, idCustomer) => {
  const result = await httpClient.get(`/order/get-ship-addr`, {
    params: {
      idSO: idSO,
      idCustomer: idCustomer,
    },
  });
  return result.data;
};

export const getPayMethod = async (idSO) => {
  const result = await httpClient.get('/order/get-pay-method', {
    params: {
      idSO: idSO,
    },
  });
  return result.data;
};

export const getShipMethod = async (idSO) => {
  const result = await httpClient.get('/order/get-ship-method', {
    params: {
      idSO: idSO,
    },
  });
  return result.data;
};

export const copySO = async (idCustomer, idSO) => {
  const result = await httpClient.post('/order/copy-so', {
    idCustomer,
    idSO,
  });
  return result.data;
};

export const getOrderItemDetails = async (idSO) => {
  const result = await httpClient.get('/order/get-item-details', {
    params: {
      idSO: idSO,
    },
  });
  return result.data;
};

export const sendOrderConfirmationEmail = async (orderData) => {
  const result = await httpClient.post('/order/send-confirmation-email', {
    orderData: orderData,
  });
  return result.data;
};
